module.exports = __webpack_public_path__ + "img/deploy-new-app.0e2b665b.png";